<template>
  <div id="content">
    <div class="contenair">
      <div>
        <form>
          <div class="step-contenair">
            <div class="elem">
              <label for="fullname">Nom / Société <span>*</span></label>
              <input
                type="text"
                v-model="form.fullname"
                id="fullname"
                name="fullname"
                placeholder="Nom et prénom ou société"
              />
            </div>

            <div class="elem">
              <label for="email">Adresse email <span>*</span></label>
              <input
                type="email"
                v-model="form.email"
                id="email"
                name="email"
                v-validate="'required|email'"
                placeholder="Adresse email"
              />
              <div class="error">{{ errors.first("email") }}</div>
            </div>

            <div class="elem">
              <label for="identifiant">Identifiant client</label>
              <input
                type="text"
                v-model="form.identifiant"
                id="identifiant"
                name="identifiant"
                placeholder="Identifiant client"
              />
            </div>

            <div class="elem">
              <label for="role">Rôles</label>
              <multiselect
                v-model="form.role"
                :options="typeList"
                name="role"
                id="role"
                :searchable="false"
                :show-labels="false"
                v-validate="'required'"
                placeholder="Sélectionnez un rôle"
              >
              </multiselect>
              <div class="error">{{ errors.first("roles") }}</div>
            </div>

            <div class="elem">
              <label for="password">Mot de passe </label>
              <input
                type="password"
                id="password"
                name="password"
                ref="password"
                v-validate="'min:6|max:35'"
                placeholder="Mot de passe"
              />
              <div class="error">{{ errors.first("password") }}</div>
            </div>

            <div class="elem">
              <label for="confirm">Confirmer le mot de passe </label>
              <input
                type="password"
                id="confirm"
                name="confirm"
                v-validate="'confirmed:password'"
                placeholder="Confirmation du mot de passe"
              />
              <div class="error">{{ errors.first("confirm") }}</div>
            </div>

            <div class="elem">
              <label for="confirm">Logo Trade URL </label>
              <input
                type="text"
                id="logo"
                v-model="form.logo_url"
                name="logo"
                placeholder="https://"
              />
              <div class="error">{{ errors.first("logo") }}</div>
            </div>
            <span class="obl">*Champs obligatoires</span>
          </div>
        </form>

        <br />
        <a style="cursor:pointer" v-on:click="goBack()" class="link-back"
          >&lt; Retour aux utilisateurs</a
        >
        <div class="form-end">
          <button class="btn-blue" v-on:click.prevent="sumbitForm">
            <i class="fa fa-save"></i> Sauvegarder
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import auth from '@/auth'

export default {
  components: {
    Multiselect,
  },
  data: function() {
    return {
      typeList: ["ADMIN", "CLIENT"],
      form: {
        identifiant: undefined,
        fullname: undefined,
        email: undefined,
        password: undefined,
        confirm: undefined,
        logo: undefined,
        auth: auth,
      },
    };
  },
  methods: {
    async sumbitForm() {
      event.preventDefault();

      this.$validator.validateAll().then(async (valid) => {
        if (valid) {
          var password = document.getElementById("password").value;
          if (password != "") {
            this.form.newPassword = password;
          }
          try {
            let { data } = await this.$axios.put("/api/users/update/" + this.$route.params._id,
              { ...this.form }
            );

            if (data) {
              this.$swal({
                position: "top-end",
                type: "success",
                title: "Modifications sauvegardées",
                showConfirmButton: false,
                timer: 1500,
              });

              if (localStorage.username === this.form.email && password != "") {
                this.auth.logout();
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    goBack() {
      this.$router.push("/users/");
    },
  },
  async mounted() {
    try {
      let { data } = await this.$axios.get("/api/users/" + this.$route.params._id);
      this.form = data;
    } catch (e) {
      this.$router.push("/?error");
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>